module.exports = __webpack_public_path__ + "media/images/athletes/2804-8b0a913276ddad20bc2e9f3f5c9d8168.png";